export default __webpack_public_path__ + "navigation-examples-route-deserialize-v1-1200-bf00185b2f00287618647e250cf66f4c.png";